import React from "react";

import styled from "@emotion/styled";

const StyledDiv = styled.div`
  /* border: 2px solid purple; */
  box-sizing: border-box;
  height: 4rem;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  color: #333;
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  z-index: 10;
  padding: 1.2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  .logo {
    height: 2rem;
  }
`;
const LOGO_SOURCE =
  "https://uploads-ssl.webflow.com/606f59a06712dbd97ef84dee/60e70d25743d7d4ad2027e68_Group%20328.svg";
const Header: React.FC = () => {
  return (
    <StyledDiv>
      <img className="logo" src={LOGO_SOURCE} />
    </StyledDiv>
  );
};

export default Header;
